import store from '@/store';
import lodash from "lodash";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { getPatientSleepByUuid, getPatientStepGroupByHourByUuid, getPatientStepGroupBydateByUuid } from '@/api/lifeStyleService';
import { sleeptype,steptype, stepcharttype } from '@/types/lifeStyleType';

export interface LifestyleState {
    loading: boolean;
    sleepdata: sleeptype[];
    stepdata: number[];
    datestepdata: stepcharttype[];
    Tossdata: number[];
    RemCountdata: number[];
    AwakeCountdata: number[];
    LightCountdata: number[];
    ComfortCountdata: number[];
    stepmeasureat: number[];
    sleep_start_time_list: string[];
    sleep_end_time_list: string[];
}

@Module({ store, dynamic: true, name: 'patientLifeStyleModule' })
class PatientLifeStyleModule extends VuexModule implements LifestyleState {
    public loading = false;
    public datestepdata: stepcharttype[] = [];
    public stepmeasureat: number[] = [];
    public sleepdata: sleeptype[] = [];
    public stepdata: number[] = [];
    public Tossdata: number[] = [];
    public RemCountdata: number[] = [];
    public AwakeCountdata: number[] = [];
    public LightCountdata: number[] = [];
    public ComfortCountdata: number[] = [];
    public sleep_start_time_list: string[] = [];
    public sleep_end_time_list: string[] = [];
    @Action({ rawError: true }) async  getSleepByUuid(LifeStyleOption): Promise<TODO> {
        this.setLoading(true);
        this.clearSleepData();
        this.clearTossData();
        this.clearRemCountData();
        this.clearAwakeCountData();
        this.clearLightCountData();
        this.clearComfortCountData();
        const sleepdata = [];
        const Toss = [];
        const RemCount = [];
        const AwakeCount = [];
        const LightCount = [];
        const ComfortCount = [];
        const sleep_start_time = [];
        const sleep_end_time = [];
        const queryData = await getPatientSleepByUuid(LifeStyleOption);
        for(const sleepclip of queryData){
            sleepclip['total_sleep_start_time'] = new Date(sleepclip['total_sleep_start_time']*1000).toLocaleString().substr(5);
            sleepclip['total_sleep_end_time'] = new Date(sleepclip['total_sleep_end_time']*1000).toLocaleString().substr(5);
            Toss.push(sleepclip['total_Toss']);
            RemCount.push(sleepclip['total_RemCount']);
            AwakeCount.push(sleepclip['total_AwakeCount']);
            LightCount.push(sleepclip['total_LightCount']);
            ComfortCount.push(sleepclip['total_ComfortCount']);
            sleep_end_time.push(sleepclip['total_sleep_end_time']);
            sleep_start_time.push(sleepclip['total_sleep_start_time']);
            sleepdata.push(sleepclip);
            
        }
        this.setSleepData(sleepdata);
        this.setTossData(Toss);
        this.setRemCountData(RemCount);
        this.setAwakeCountData(AwakeCount);
        this.setLightCountData(LightCount);
        this.setComfortCountData(ComfortCount);
        this.setSleepStartTimeList(sleep_start_time);
        this.setSleepEndTimeList(sleep_end_time);
        this.setLoading(false);
    }

    @Action({ rawError: true }) async  getStepGroupByHourByUuid(LifeStyleOption): Promise<TODO> {
        this.setLoading(true);
        this.clearStepData();
        this.clearStepMeasureAt();
        const stepdata = [];
        const stepmeasureat = [];
        const queryData = await getPatientStepGroupByHourByUuid(LifeStyleOption);
        for(const stepclip of queryData){
            stepdata.push(stepclip['value']);
            stepmeasureat.push(stepclip['measure_at']*1000);
        }
        this.setStepData(stepdata);
        this.setStepMeasureAt(stepmeasureat);
        this.setLoading(false);
    }

    @Action({ rawError: true }) async  getStepGroupBydateByUuid(LifeStyleOption): Promise<TODO>{
        this.setLoading(true);
        this.clearDateStepData();
        const queryData =await getPatientStepGroupBydateByUuid(LifeStyleOption);
        const data = [];
        queryData.forEach((val,index)=>{
            data.push({
                x:queryData[index]['measure_at'] * 1000,
                y:queryData[index]['value']
            });
        });
        await this.setDateStepData(data);
        this.setLoading(false);
    }

    @Action async clearStepData(){
        this.setStepData([]);
    }

    @Action async clearDateStepData(){
        this.setDateStepData([]);
    }

    @Action async clearStepMeasureAt(){
        this.setStepMeasureAt([]);
    }

    @Action async clearSleepData(){
        this.setSleepData([]);
    }
    @Action async clearTossData(){
        this.setTossData([]);
    }
    @Action async clearComfortCountData(){
        this.setComfortCountData([]);
    }
    @Action async clearLightCountData(){
        this.setLightCountData([]);
    }
    @Action async clearAwakeCountData(){
        this.setAwakeCountData([]);
    }
    @Action async clearRemCountData(){
        this.setRemCountData([]);
    }
    @Action async clearSleepEndTimeList(){
        this.setSleepEndTimeList([]);
    }
    @Action async clearSleepStartTimeList(){
        this.setSleepStartTimeList([]);
    }

    @Mutation setLoading(loading: boolean){
        this.loading = loading;
    }

    @Mutation setStepData(stepdata){
        this.stepdata = lodash.cloneDeep(stepdata);
    }

    @Mutation setDateStepData(datestepdata){
        this.datestepdata = lodash.cloneDeep(datestepdata);
    }

    @Mutation setStepMeasureAt(stepmeasureat){
        this.stepmeasureat = lodash.cloneDeep(stepmeasureat);
    }

    @Mutation setSleepData(sleepdata):void{
        this.sleepdata = lodash.cloneDeep(sleepdata);
    }
    @Mutation setTossData(Toss):void{
        this.Tossdata = lodash.cloneDeep(Toss);
    }
    @Mutation setComfortCountData(ComfortCount):void{
        this.ComfortCountdata = lodash.cloneDeep(ComfortCount);
    }
    @Mutation setAwakeCountData(AwakeCount):void{
        this.AwakeCountdata = lodash.cloneDeep(AwakeCount);
    }
    @Mutation setLightCountData(LightCount):void{
        this.LightCountdata = lodash.cloneDeep(LightCount);
    }
    @Mutation setRemCountData(RemCount):void{
        this.RemCountdata = lodash.cloneDeep(RemCount);
    }
    @Mutation setSleepEndTimeList(sleep_end_time):void{
        this.sleep_end_time_list = lodash.cloneDeep(sleep_end_time);
    }
    @Mutation setSleepStartTimeList(sleep_start_time):void{
        this.sleep_start_time_list = lodash.cloneDeep(sleep_start_time);
    }
}

export const patientLifeStyleModule = getModule(PatientLifeStyleModule);